import { OrderedMap } from "immutable";

const ProjectCompletedTasksMap = OrderedMap;

export default ProjectCompletedTasksMap;
